import React from "react";
import { useState, useEffect } from "react";
import { SisternodeOutlined, EditOutlined, DeleteOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Tooltip, Avatar, Popover, List, Input, Typography, Button, message } from "antd";
import './Marquee.css';
import axios from "axios";
import Cookies from "js-cookie";

const MarqueeHeader = () => {
    const jwtToken = Cookies.get("jwt_token");
    const [marqueeContent, getMarqueeContent] = useState([]);
    const [newContent, setNewContent] = useState('');
    const [editingIndex, setEditingIndex] = useState(null);
    const [editingText, setEditingText] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        MarqueContent();
    }, []);

    const MarqueContent = async () => {
        try {
            axios({
                url:
                    `${process.env.REACT_APP_BASE_URL}DashBoard/get-marquee-data`,
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            })
                .then((resp) => {
                    getMarqueeContent(resp.data)
                })
        }
        catch (error) {
            message.error("Unable to load data...")
        }
    };

    const addContent = async (e) => {
        e.stopPropagation();
        const trimmedContent = newContent.trim();
        if (trimmedContent.length === 0) {
            setError('*Please enter text');
            setNewContent('')
            return;
        }
        try {
            const config = {
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                }
            }
            const data = {
                Content: newContent
            };
            const url = `${process.env.REACT_APP_BASE_URL}DashBoard/add-new-content`
            setLoading(true)
            const res = await
                axios.post(url, data, config)
            if (res.data.statusCode == 200) {
                message.success(res.data.message)
                setNewContent('')
                MarqueContent()
                setLoading(false)
            } else if (res.data.StatusCode == 500) {
                message.warning(res.data.message)
                setLoading(false)
            }
        } catch (error) {
            message.error("Error while adding new content");
            setLoading(false)
        }
    }
    const startEdit = (e, id, content) => {
        e.stopPropagation();
        setEditingIndex(id)
        setEditingText(content)
    };
    const saveEdit = async (e, id) => {
        e.stopPropagation();
        try {
            if (editingText.trim() !== '') {
                const config = {
                    headers: {
                        "content-type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    }
                }
                const data = {
                    Id: id,
                    Content: editingText
                };
                const url = `${process.env.REACT_APP_BASE_URL}DashBoard/update-marquee-content`
                const res = await axios.put(url, data, config)
                if (res.data.statusCode == 200) {
                    message.success(res.data.message)
                    setEditingIndex(null)
                    setEditingText('')
                    MarqueContent()
                } else if (res.data.StatusCode == 500) {
                    message.warning(res.data.message)
                }
            }
        }
        catch (error) {
            message.error("Error while updating content")
        }
    };

    const cancelEdit = (e) => {
        e.stopPropagation();
        setEditingIndex(null);
        setEditingText('');
    };
    const handleDelete = async (e, index) => {
        e.stopPropagation();
        const recordId = index
        try {
            const config = {
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                }
            }
            const url = `${process.env.REACT_APP_BASE_URL}DashBoard/delete-content?recordid=` + recordId
            const res = await
                axios.delete(url, config)
            if (res.data.statusCode == 200) {
                message.success(res.data.message)
                MarqueContent()
            } else if (res.data.StatusCode == 500) {
                message.warning(res.data.message)
            }
        } catch (error) {
            message.error("Error while deleting content")
        }
    }
    
    const contentOnchange = (e) => {
        setError('')
        setNewContent(e)
    }

    const marqueContent = (
        <>
            <div style={{ display: "flex" }}>
                <div style={{ marginLeft: "5%" }}>
                    <Input
                        type="text"
                        value={newContent}
                        size="small"
                        style={{ width: '97%', height: '30px', marginRight: '26px' }}
                        onChange={(e) => contentOnchange(e.target.value)}
                    />
                    {error && <p style={{ color: 'red', marginTop: '0' }}>{error}</p>}
                </div>
                <Button onClick={(e) => addContent(e)} type="primary" loading={loading} style={{ backgroundColor: '#002766', height: '30px' }}>Add</Button>
            </div>
            <div style={{ overflowY: 'auto', height: '40%' }}>
                <List
                    size="small"
                    dataSource={marqueeContent}
                    renderItem={(item, i) => (
                        <List.Item
                            key={item.Id}
                            actions={editingIndex === item.Id ? [
                                <Typography.Link ><CheckOutlined onClick={(e) => saveEdit(e, item.Id)} size="small" style={{ color: 'green' }} /> </Typography.Link>,
                                <Typography.Link ><CloseOutlined onClick={(e) => cancelEdit(e)} size="small" style={{ color: 'red' }} /> </Typography.Link>
                            ] : [
                                <Typography.Link ><EditOutlined onClick={(e) => startEdit(e,item.Id, item.Content)} size="small" />  </Typography.Link>,
                                <Typography.Link ><DeleteOutlined onClick={(e) => handleDelete(e,item.Id)} size="small" style={{ color: 'red' }} /></Typography.Link>
                            ]}
                        >
                            {editingIndex === item.Id ? (
                                <Input
                                    value={editingText}
                                    onChange={(e) => setEditingText(e.target.value)}
                                    onPressEnter={() => saveEdit(item.Id)}
                                />
                            ) : (
                                <span>{item.Content}</span>
                            )}
                        </List.Item>

                    )}
                />
            </div>
        </>
    );
    return (
        <div className="mq-wholediv">
            <div style={{ width: '93%', overflow: 'hidden' }}>
                <div className="mq-scrolling">
                    {
                        marqueeContent.map((item, i) => {
                            return (
                                <div className="mq-items">
                                    <li className="mq-bullet"></li>
                                    <span key={i} className="mq-span">{item.Content}</span>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className="icon-div">
                <Popover placement="bottom" content={marqueContent} trigger="click" >
                    <Tooltip title="Modify scrolling content">
                        <Avatar icon={<SisternodeOutlined />} />
                    </Tooltip>
                </Popover>
            </div>
        </div>
    )
}

export default MarqueeHeader;